import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlice.js";
import calendaryReducer from "./features/appointments/calendarySlice.js";
import chatsReducer from "./features/chats/chatSlice.js";
import clinicReducer from "./features/clinic/clinicSlice.js";
import assistantReducer from "./features/assistant/assistantSlice";
import crmReducer from "./features/crm/crmSlice.js";
import hrReducer from "./features/hr/hrSlice.js";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        calendary: calendaryReducer,
        chat: chatsReducer,
        clinic: clinicReducer,
        assistant: assistantReducer,
        crm: crmReducer,
        hr: hrReducer,
    },
});

export default store;